import { api } from '@src/constants/api';
import { createMiddleware, Next } from '@src/utils';
import { jobsActions } from '@src/store/reducers/jobsReducer';

export const createJobsMiddleware = (http: any) => {
    const restServiceUrl: string = api.restServiceUrl;
    const transformResponse = (action: any) => (data: any, header: any) => {
        return window['cTransformResponse'](data, header, action);
    };
    return createMiddleware({
        [jobsActions.GET_JOBS_EXECUTING]: async (action: any, next: Next) => {
            const url = `${restServiceUrl}Projects/GetJobsExecuting`;
            const response = await http({ method: 'GET', url, SilentRequest: action.silentRequest, transformResponse: transformResponse(action) });
            next({ type: jobsActions.RECEIVED_JOBS_EXECUTING, payload: { jobsExecuting: response.data } });
            return response;
        },
        [jobsActions.GET_JOBS_EXECUTING_BY_PROJ]: async (action: any, next: Next) => {
            const url = `${restServiceUrl}Projects/${action.payload.projId}/GetJobsExecuting`;
            const response = await http({ method: 'GET', url, SilentRequest: action.silentRequest, transformResponse: transformResponse(action) });
            next({ type: jobsActions.RECEIVED_JOBS_EXECUTING_BY_PROJ, payload: { jobsExecutingByProj: response.data } });
            return response;
        },
        [jobsActions.GET_JOBS_EXECUTING_BY_ENV]: async (action: any, next: Next) => {
            const url = `${restServiceUrl}Projects/${action.payload.projId}/Environment/${action.payload.envId}/GetJobsExecuting`;
            const response = await http({ method: 'GET', url, SilentRequest: action.silentRequest });
            next({ type: jobsActions.RECEIVED_JOBS_EXECUTING_BY_ENV, payload: { jobsExecutingByEnv: response.data } });
            return response;
        },
        [jobsActions.GET_JOBS_EXECUTED]: async (action: any, next: Next) => {
            const url = `${restServiceUrl}Projects/GetJobsExecuted/Period/${action.payload.period}`;
            const response = await http({ method: 'GET', url, SilentRequest: action.silentRequest });
            next({ type: jobsActions.RECEIVED_JOBS_EXECUTED, payload: { jobsExecuted: response.data } });
            return response;
        },
        [jobsActions.GET_JOBS_EXECUTED_BY_PROJ]: async (action: any, next: Next) => {
            const url = `${restServiceUrl}Projects/${action.payload.projId}/GetJobsExecuted/Period/${action.payload.period}`;
            const response = await http({ method: 'GET', url, SilentRequest: action.silentRequest });
            next({ type: jobsActions.RECEIVED_JOBS_EXECUTED_BY_PROJ, payload: { jobsExecutedByProj: response.data } });
            return response;
        },
        [jobsActions.GET_JOBS_EXECUTED_BY_ENV]: async (action: any, next: Next) => {
            const payload = action.payload;
            const url = `${restServiceUrl}Projects/${payload.projId}/Environment/${payload.envId}/GetJobsExecuted/Period/${payload.period}`;
            const response = await http({ method: 'GET', url, SilentRequest: action.silentRequest });
            next({ type: jobsActions.RECEIVED_JOBS_EXECUTED_BY_ENV, payload: { jobsExecutedByEnv: response.data } });
            return response;
        },
        [jobsActions.GET_JOB_DATA]: async (action: any, next: Next) => {
            const url = `${restServiceUrl}Projects/GetJobTaskProccessData/${action.payload.jobQId}`;
            const response = await http({ method: 'GET', url, SilentRequest: action.silentRequest });
            next({ type: jobsActions.RECEIVED_JOB_DATA, payload: { jobData: response.data } });
            return response;
        },
        [jobsActions.GET_JOB_DATA_BY_TASK_ID]: async (action: any, next: Next) => {
            const url = `${restServiceUrl}Projects/GetJobTaskProccessData/${action.payload.jobQId}/fromId/${action.payload.fromId}`;
            const response = await http({ method: 'GET', url, SilentRequest: action.silentRequest });
            next({ type: jobsActions.RECEIVED_JOB_DATA, payload: { jobData: response.data } });
            return response;
        },
        [jobsActions.GET_JOB_EXECUTION]: async (action: any, next: Next) => {
            const url = `${restServiceUrl}Jobs/${action.payload.jobQId}/Execution`;
            const response = await http({ method: 'GET', url, SilentRequest: action.silentRequest, transformResponse: transformResponse(action) });
            next({ type: jobsActions.RECEIVED_JOB_EXECUTION, payload: { jobExecution: response.data } });
            return response;
        },
        [jobsActions.KILL_JOB]: async (action: any) => {
           
            //const url = `${restServiceUrl}Projects/Jobs/${action.payload.jobQId}/actionType/${action.payload.actionType}`;
            //const response = await http({ method: 'PUT', url, SilentRequest: action.silentRequest, transformResponse: transformResponse(action) });

            const response = await http({
                url: `${restServiceUrl}Projects/Jobs/${action.payload.jobQId}/actionType/${action.payload.actionType}`,
                method: 'PUT',
                data: { changeParams: [] },
                headers: { 'Content-Type': 'application/json;charset=utf-8' }
            });
            
            return response;
        }
    });
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/middlewares/jobs.middleware.ts